export default __webpack_public_path__ + "static/media/academy.2f637bfd.svg";